import reset from "react-style-reset";
import { createGlobalStyle } from "styled-components";
import { Color } from "./Color";
import { RoundedCorners } from "./Mixins";

const PublicStyles = createGlobalStyle`
${reset}

*, *::before, *::after {
  box-sizing: inherit;
}

html {
    font-size: 62.5%; // 1rem = 10px 
}

body {
    box-sizing: border-box;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    font-family: system-ui, sans-serif;
    color: ${Color.White};
    line-height: 160%;
    font-size: 1.6rem;
}

#__next {
    min-height: 100vh;
}

h1, h2, h3, h4, h5 {
    font-family: 'PT Sans', sans-serif;
    text-align: center;
}

    h1 {
        font-size: 3rem;
        font-weight: bold;
        margin: 0 0 1rem 0;  
    }

    h2 {
        font-size: 2.3rem;
        text-align: left;
        margin: 0 0 0.7rem 0;
        font-weight: bold;  
    }

    h3 {
        font-size: 2.0rem;
        text-align: left;
        margin: 0 0 0.5rem 0;
        font-weight: bold;  
    }
    h4 {
        font-size: 1.75rem;
        text-align: left;
        margin: 0 0 0.5rem 0;
        font-weight: bold;  
    }
    h5 {
        font-size: 1.6rem;
        text-align: left;
        margin: 0 0 0.3rem 0;
        font-weight: bold;  
    }

p {
    margin-bottom: 3rem;
}

ul, ol {
    margin-bottom: 3rem;
}

ol {
    list-style: decimal;
}

li {
    margin: 0 0 1.5rem 2rem;
}

ul li {
    list-style-type: disc;
}


b {
    font-weight: 700;
}

i {
    font-style: italic;
}

/* Form Styles */

input, button, textarea, select {
    font-family: inherit;
    font-size: inherit;
}

input {
    box-sizing: inherit;
    display: block;
    width: 100%;
    margin-bottom: 2rem;
    padding: 1rem;
    border: none;
    background: ${Color.White};
    color: ${Color.Grey2};
    font-size: 1.7rem;
    ${RoundedCorners}
} 


textarea {
    width: 100%;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
    padding: 1rem;
    border: none;
    background: ${Color.White};
    color: ${Color.Grey2};
    font-size: 1.7rem;
    min-height: 10rem;
    ${RoundedCorners}
}

input[type=checkbox] {
    display: inline;
    margin: 0 1rem 0 0;
    width: 2rem;
    height: 2rem;
}

button {
    display: block;
    margin: 2rem auto 4rem auto;
    padding: 1.5rem 4rem;
    border: none;
    background-size: 200% auto;
    color: ${Color.White};
    box-shadow: ${Color.OrangeShadow} 0 0.5rem 2rem 0;
    background-image: linear-gradient(to right, ${Color.Orange5} 0%, ${Color.Orange6} 100%);
    font-size: 1.6rem;
    ${RoundedCorners}
}
    button:hover {
        background-image: linear-gradient(to right, ${Color.Orange5} 0%, ${Color.Orange6} 100%);
    } 
    button:not(:disabled) {
        cursor: pointer;
    }



.PhoneInputInput {
  margin-bottom: 0px;
}

.PhoneInputCountrySelectArrow {
  color: ${Color.Grey2};
  opacity: 100;
  padding-left: 0.2rem; 
  padding-right: 0.2rem; 
  border-bottom: 2px solid ${Color.Grey2};
  border-right:  2px solid ${Color.Grey2};
  width: 0.8rem;
  height: 0.8rem;
  margin-top: -1px;
}

.grecaptcha-badge { 
    visibility: hidden !important;
}


`;

export default PublicStyles;
